var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.homePath)?_c('router-link',{class:['station-home-link', { open: _vm.showStationHomeLink }],attrs:{"to":_vm.homePath}},[_c('Icon',{attrs:{"icon":"home-alt"}}),_vm._v(" Home ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }